import { createSlice } from '@reduxjs/toolkit';

const categoryProductSlice = createSlice({
    name: 'categoryProduct',
    initialState: {
        categoryProduct: [], // Store products for a specific category
    },
    reducers: {
        setCategoryProducts(state, action) {
            state.categoryProduct = action.payload; // Set products for a category
        },
        clearCategoryProducts(state) {
            state.categoryProduct = []; // Clear the product list when needed
        },
    },
});

export const { setCategoryProducts, clearCategoryProducts } = categoryProductSlice.actions;
export default categoryProductSlice.reducer;